export enum EventType {
	Fallback = 99,
	MahnungSentAsEmail = 0,
	MahnungSentAsPhysicalMail = 1,
	MahnungCalledCustomer = 2,
	CalculatedOrder = 200,
	UserAskForGoogleReview = 3,
	UserAskedWhyTheyDidNotOrder = 4,
	ArticleCreated = 5,
	ArticleDeleted = 6,
	ArticleValidated = 400,
}
